// Profil-Nachbau F-08, F-19 (output/profil-team-20261014/BAU-COCKPIT.md 0.4, 1.3; Auftrag PF-506): Adresse und Teile des
// Firmen-Cockpits /ki-cockpit, einer Bereichsseite der Bereichs-Ebene (components/bereichsEbene.ts). Ohne JSX, damit die
// Bereichs-Ebene den Pfad erkennt, ohne die Seite zu laden. Die Teile stehen als Einträge in der Leiste; der offene Teil und
// der Zeitraum stehen in der Adresse (?reiter=…&zeitraum=… bzw. von=…&bis=…). Die Regeln der Abfrage stehen nur in zeitraum.ts.
import { reiterLesen, reiterSetzen } from './zeitraum';

export const KI_COCKPIT_PFAD = '/ki-cockpit';
export const istKiCockpitPfad = (pfad: string) => pfad.replace(/\/+$/, '') === KI_COCKPIT_PFAD;

// Teile des Firmen-Cockpits in der Reihenfolge der Leiste (BAU-COCKPIT 0.4, 1.3). „teams“ nur mit teamsVerfuegbar; „export“ ab PF-506-2.
// Seit F-25 (PF-GC-seite-1, E-25-2) geht „Verlauf“ in der Übersicht auf; ?reiter=verlauf zeigt die Übersicht (teilAusAdresse).
export type FirmenTeil = 'uebersicht' | 'personen' | 'teams' | 'quellen' | 'aufmerksamkeit' | 'export';
export const VORGABE_TEIL: FirmenTeil = 'uebersicht';

export function firmenTeile({ teamsVerfuegbar, mitExport }: { teamsVerfuegbar: boolean; mitExport: boolean }): FirmenTeil[] {
  return ['uebersicht', 'personen', ...(teamsVerfuegbar ? ['teams' as const] : []), 'quellen', 'aufmerksamkeit', ...(mitExport ? ['export' as const] : [])];
}
/** Der offene Teil aus der Abfrage; unbekannt, fehlend oder hier nicht vorhanden (etwa „teams“ ohne Teams): die Übersicht. */
export const teilAusAdresse = (search: string, teile: FirmenTeil[]): FirmenTeil => reiterLesen(new URLSearchParams(search), teile, VORGABE_TEIL);
/** Adresse eines Teils: Zeitraum und alle anderen Teile der Abfrage bleiben, nur reiter wechselt; die Übersicht steht ohne reiter. */
export function kiCockpitAdresse(teil: FirmenTeil, search: string): string {
  const abfrage = reiterSetzen(new URLSearchParams(search), teil, VORGABE_TEIL).toString();
  return abfrage ? `${KI_COCKPIT_PFAD}?${abfrage}` : KI_COCKPIT_PFAD;
}
